/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const EVENT_NAMES = {
  TAP: 'tap',
  MOVEMENTS_CLICK: 'aa_home_movements_clicked',
} as const;

export const CATEGORY = {
  home_arrow: 'Home|arrow',
  home_chip: 'Home|chip',
  movements: 'recommendationListing|MoveMents',
} as const;

export const LINE_OF_BUSINESS = {
  socialUgc: 'SocialUGC',
} as const;

export const SocialActions = {
  Header_Tap: 'Header_Tap',
  Footer_Chip_Tap: 'Footer_Chip_Tap',
} as const;
